import { StandardFormCode } from '../codeHighlights/forms/StandardFormCode';

const StandardForm = () => {
  return (
    <>
      <h2>Standard Form</h2>
      <form noValidate={true} method="" id="bootstrapForm02">
        <div className="my-3">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Email address
            <em>required</em>
          </label>
          <input
            type="email"
            className="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="E-Mail"
          />
          <div id="emailHelp" className="form-text">
            We'll never share your email with anyone else.
          </div>
        </div>

        <div className="my-3">
          <label htmlFor="exampleTextField" className="form-label">
            Text
          </label>
          <input
            type="text"
            className="form-control"
            id="exampleTextField"
            autoComplete="on"
          />
        </div>

        <div className="my-3">
          <label htmlFor="inputPassword5" className="form-label">
            Password
          </label>
          <input
            type="password"
            id="inputPassword5"
            className="form-control"
            aria-describedby="passwordHelpBlock"
            autoComplete="on"
            required
          />
          <div id="passwordHelpBlock" className="form-text">
            Your password must be 8-20 characters long, contain letters and
            numbers, and must not contain spaces, special characters, or emoji.
          </div>
        </div>

        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="exampleCheck1"
            required
          />
          <label className="form-check-label" htmlFor="exampleCheck1">
            Accept terms & conditions
          </label>
        </div>

        <div className="form-check mb-4">
          <input
            type="checkbox"
            className="form-check-input"
            id="exampleCheck2"
            required
            onChange={e => {}}
          />
          <label className="form-check-label" htmlFor="exampleCheck2">
            Check me out
          </label>
        </div>

        <button
          id="standard-form-submit"
          type="submit"
          className="btn btn-secondary me-2"
        >
          Submit
        </button>
        <button id="resetForm" className="btn btn-light" type="reset">
          Reset form
        </button>
      </form>

      <div className="row mt-5">
        <div className="col-12">
          <StandardFormCode />
        </div>
      </div>
    </>
  );
};

export default StandardForm;
